<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vT7OnL/tc-custom/scover.jpg?1717895645079" alt="This image is the cover for the book Solomon Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Solomon Time
      </h1>
      <p class="bookDescription body article font2">
        <p>Who hasn't fantasized about dismantling his or her hassled, wired-up life for a simpler existence? Yet who among us has the will and opportunity to do it? The answer, of course, is very few.<br/><br/>Will Randall, a young English schoolmaster, had such a chance -- and took it. He uprooted his conventional First World life and let himself be blown to one of the farthest and most beautiful corners of the earth, the Solomon Islands of the South Pacific. In the entertaining tradition of Bill Bryson's <i>In a Sunburned Country,</i> this is the story of <i>Solomon Time.</i><br/><br/>From the first, it's an improbable journey. In a chance encounter on a rugby field, Randall meets a doddering old man known as "the Commander," who has retired to England after running a cocoa plantation in the South Pacific for thirty years. Six months later, the Commander dies and his will is read: he wants someone to travel to his beloved, long-missed island -- where his plantation has fallen into ruin -- and devise a way for the natives to support themselves. If successful, they might avoid poverty, build a new school, and even fend off the greedy developers circling their peaceful waters.<br/><br/>It's a mission of noblesse oblige, yet possibly a fool's errand, too. Randall agrees to go.<br/><br/>Spread across the Tropic of Capricorn, the Solomon Islands are not so much the Pacific archipelago that time forgot as the one that forgets time. Randall's new home is Mendali, a fishing village so remote it can be reached only by motorized canoe. But the people of the village, some with cheeks engraved with a rising sun, are welcoming, for they remember the Commander kindly, and still practice a pagan Anglicanism in a church he built for them in 1956. They sleep in houses made of leaves and live on fish of every sort, mud crabs, yams, ngali nuts, even the honeycomb of termites.<br/><br/>Randall decides that the villagers could raise chickens, and they greet the idea with enthusiasm. But finding live chicken eggs in their watery world proves wildly difficult, and Randall must chase after the eggs over shark-infested seas and through jungles where strange characters reside, including a one-eyed dwarf and a tattooed lady.<br/><br/>One couldn't imagine a better man than Will Randall to help the people of Mendali meet the twenty-first century on their own terms. But will he succeed?<br/><br/><i>Solomon Time</i> is a moving and witty account of one man's accidental adventure in paradise and is certain to enchant explorers and armchair travelers alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Will Randall
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scribner
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a014bee4